<template>
  <v-container fluid>
    <v-layout justify-center>
      <v-flex lg7 md7 sm8 xs12>
        <h2 class='amaze-title'>Amaze</h2>
        <p>Need a reset? Hey, it happens. <br />Enter your email address below to reset your password.</p>

        <v-form ref="resetForm" v-model="valid" @submit.prevent @keyup.enter.native="submitForm()" class='mt-5'>

          <v-text-field label="E-mail Address" v-model="email" :rules="emailRules" required></v-text-field>
          <v-btn color="primary" class="mt-3" @click="submitForm()">
            Reset me!
          </v-btn>
        </v-form>
        <p class='mt-5'>
          <router-link to="/">Return to Login</router-link>
        </p>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<style>
</style>

<script>
export default {
  data() {
    return {
      valid: false,
      email: "",
      emailRules: [v => !!v || "Email is required"]
    };
  },
  methods: {
    submitForm() {
      if (this.$refs.resetForm.validate()) {
        let formData = {
          email: this.email
        };
        this.$http.post("password/forgot", formData).then(
          response => {
            this.$router.push({ path: "/reset-successful" });
          },
          response => {
            this.$store.commit("updateMessage", {
              message:
                  "There is no account registered with that e-mail address.",
              snackbar: true
            });
          }
        );
      } else {
        this.$store.commit("updateMessage", {
          message:
              "Nice try, but some required information is missing. Give it another go!",
          snackbar: true
        });
      }
    }
  }
};
</script>
